import { observable, reaction } from "mobx"

import { devModeState } from "@/hooks/useDevMode.ts"
import { Model } from "@/lib/Model.ts"

import type { AiAgentTaskSettings } from "@/lib/client/generated/TypeDefinitions.ts"

export class TaskSettingsModel extends Model {
  readonly useBrowserVerification = observable.box(false)
  readonly mockForTesting = observable.box(false)
  readonly accessUserBrowserPreview = observable.box(false)
  readonly useV2Previews = observable.box(false)
  readonly useExploreCodebaseSubagent = observable.box(false)

  constructor(readonly isNewProject: boolean) {
    super("TaskSettingsModel")

    this.lifetime.add(reaction(() => devModeState.get(), (value) => {
      this.accessUserBrowserPreview.set(value)
      // this.useV2Previews.set(value)
      this.useExploreCodebaseSubagent.set(value)
    }, { fireImmediately: true }), "TaskSettingsModel:listenToDevMode")
  }

  getSettings(): AiAgentTaskSettings {
    return {
      ...emptyAiAgentTaskSettings,
      useBrowserVerification: this.useBrowserVerification.get(),
      mockForTesting: this.mockForTesting.get(),
      accessUserBrowserPreview: this.accessUserBrowserPreview.get(),
      useV2Previews: this.isNewProject ? this.useV2Previews.get() : null,
      useExploreCodebaseSubagent: this.useExploreCodebaseSubagent.get(),
    }
  }
}

const emptyAiAgentTaskSettings: AiAgentTaskSettings = {
  llmProfile: null,
  useCodeSearchWithEmbeddings: null,
  skipVerification: null,
  maxAgentIterationsCount: null,
  maxFixAttemptsCount: null,
  useRepoMap: null,
  viewFileWindowSize: null,
  maxSearchResults: null,
  useMemories: null,
  useBrowserVerification: null,
  mockForTesting: null,
  accessUserBrowserPreview: null,
  useV2Previews: null,
  useExploreCodebaseSubagent: null,
}
